import { styled } from '../../../common/ui'

export const TextView = styled.div`
  font-size: 18px;
  font-weight: normal;
  color: #fff;
  padding: 0 0 25px 0;
`
